var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0254 20.5707L16.0257 17.357C16.0259 15.5818 14.5869 14.1426 12.8117 14.1426H5.61444C3.83951 14.1426 2.40059 15.5814 2.40039 17.3563L2.40002 20.5707M21.5997 20.5709L21.6 17.3571C21.6002 15.582 20.1612 14.1428 18.386 14.1428M15.4064 4.06051C16.1957 4.64615 16.7072 5.58501 16.7072 6.64334C16.7072 7.70167 16.1957 8.64052 15.4064 9.22616M12.4938 6.64316C12.4938 8.41824 11.0548 9.85722 9.27977 9.85722C7.50469 9.85722 6.06571 8.41824 6.06571 6.64316C6.06571 4.86809 7.50469 3.42911 9.27977 3.42911C11.0548 3.42911 12.4938 4.86809 12.4938 6.64316Z",
    stroke: "#1F3C5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersProfile);
export default __webpack_public_path__ + "static/media/users-profile.cf00715819021b4ec7c456bc675d27cf.svg";
export { ForwardRef as ReactComponent };